import { render } from "./CustomerDistribution.vue?vue&type=template&id=c4deddcc&scoped=true"
import script from "./CustomerDistribution.vue?vue&type=script&lang=js"
export * from "./CustomerDistribution.vue?vue&type=script&lang=js"

import "./CustomerDistribution.vue?vue&type=style&index=0&id=c4deddcc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4deddcc"],['__file',"src/views/h5/crm/customer/CustomerDistribution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4deddcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4deddcc', __exports__)) {
    api.reload('c4deddcc', __exports__)
  }
  
  module.hot.accept("./CustomerDistribution.vue?vue&type=template&id=c4deddcc&scoped=true", () => {
    api.rerender('c4deddcc', render)
  })

}


export default __exports__